export default {
  items: [],
  sort: {
    page: 1,
    column: 'country',
    order: 'ascending',
    limit: 50,
  },
  more: true,
  loading: false,
  total: 0,
  countries: [
    {
      name: 'Italy',
      cities: [
        'Ascoli Piceno',
        'Benevento',
        'Bergamo',
        'Bologna',
        'Brescia',
        'Cagliari',
        'Castellammare di Stabia (Naples)',
        'Chiavari (Genoa)',
        'Cittadella (Padua)',
        'Cosenza',
        'Cremona',
        'Crotone',
        'Empoli (Florence)',
        'Ferrara',
        'Florence',
        'Frosinone',
        'Genoa',
        'La Spezia',
        'Lecce',
        'Livorno',
        'Milan',
        'Naples',
        'Palermo',
        'Parma',
        'Perugia',
        'Pescara',
        'Pisa',
        'Pordenone',
        'Rome',
        'Salerno',
        'Sassuolo',
        'Trapani',
        'Turin',
        'Udine',
        'Venice',
        'Verona',
      ]
    }
  ]
};
